import { render } from "./Month.vue?vue&type=template&id=b7b9a434&scoped=true&ts=true"
import script from "./Month.vue?vue&type=script&lang=ts"
export * from "./Month.vue?vue&type=script&lang=ts"

import "./Month.vue?vue&type=style&index=0&id=b7b9a434&scoped=true&lang=less"

import exportComponent from "D:\\work\\project\\mobile-mpe\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7b9a434"]])

export default __exports__